import { sendPost } from '@utils/request';

export const fetchActivityDetail = data => {
  const url = '/api/newMallActivity/getActivityPageInfo';
  return sendPost({ url, data });
};

export const fetchActivityGoodsList = data => {
  const url = '/api/newMallActivity/getActivityTagInfo/tag';
  return sendPost({ url, data });
};